import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BeTarefaCartao, BeTarefaChecklist, BeTarefaComentario, BeTarefaEtiqueta } from '@app/models/be-tarefa';
import { DialogTarefaEtiquetaComponent } from '@app/components/dialog-tarefa-etiqueta/dialog-tarefa-etiqueta.component';
import { HttpClient } from '@angular/common/http';
import { SnackBarService } from '@app/services/snack-bar.service';

export interface DialogTarefaData {
  cartao: BeTarefaCartao;
  etiquetas: BeTarefaEtiqueta[];
}

@Component({
  selector: 'app-dialog-tarefa',
  templateUrl: './dialog-tarefa.component.html',
  styleUrls: ['./dialog-tarefa.component.css']
})
export class DialogTarefaComponent {
  public novoComentario = '';
  public enviandoComentario = false;
  public constructor(
    private readonly dialogRef: MatDialogRef<DialogTarefaComponent>,
    private readonly dialog: MatDialog,
    private readonly http: HttpClient,
    private readonly snackBarService: SnackBarService,
    @Inject(MAT_DIALOG_DATA) public data: DialogTarefaData
  ) { }

  public adicionarChecklist(): void {
    this.data.cartao.checklists.push({
      idTarefaCartao: this.data.cartao.id ?? 0,
      dsItem: '',
      nrOrdem: this.data.cartao.checklists.length,
      blConcluido: false
    });
  }

  public removerChecklist(indice: number): void {
    this.data.cartao.checklists.splice(indice, 1);
  }

  public adicionarEtiqueta(): void {
    this.dialog.open(DialogTarefaEtiquetaComponent, {
      autoFocus: true,
      disableClose: true,
      width: '460px',
      maxWidth: 'calc(100vw - 32px)',
      data: {}
    }).afterClosed().subscribe(etiqueta => {
      if (!etiqueta) return;
      this.http.post<BeTarefaEtiqueta>('/api/Tarefas/etiquetas', etiqueta).subscribe({
        next: novaEtiqueta => {
          this.data.etiquetas.push(novaEtiqueta);
          this.data.cartao.idsEtiquetas = [...new Set([...this.data.cartao.idsEtiquetas, novaEtiqueta.id!])];
        },
        error: erro => this.snackBarService.exibirErro(erro?.error?.message ?? 'Não foi possível criar a etiqueta.')
      });
    });
  }

  public etiquetasSelecionadas(): BeTarefaEtiqueta[] {
    return this.data.etiquetas.filter(etiqueta => this.data.cartao.idsEtiquetas.includes(etiqueta.id!));
  }

  public corTextoEtiqueta(cor: string): string {
    const hexadecimal = cor.replace('#', '');
    const vermelho = parseInt(hexadecimal.substring(0, 2), 16);
    const verde = parseInt(hexadecimal.substring(2, 4), 16);
    const azul = parseInt(hexadecimal.substring(4, 6), 16);
    return (vermelho * 299 + verde * 587 + azul * 114) / 1000 < 150 ? '#fff' : '#1f2933';
  }

  public possuiChecklistInvalido(): boolean {
    return this.data.cartao.checklists.some(item => !item.dsItem.trim());
  }

  public adicionarComentario(): void {
    const dsComentario = this.novoComentario.trim();
    if (this.enviandoComentario || !dsComentario || !this.data.cartao.id) return;
    this.enviandoComentario = true;
    this.http.post<BeTarefaComentario>(`/api/Tarefas/cartoes/${this.data.cartao.id}/comentarios`, { dsComentario }).subscribe({
      next: comentario => {
        this.data.cartao.comentarios.unshift(comentario);
        this.novoComentario = '';
        this.enviandoComentario = false;
        this.snackBarService.exibirSucesso('Comentário adicionado.');
      },
      error: erro => {
        this.enviandoComentario = false;
        this.snackBarService.exibirErro(erro?.error?.message ?? 'Não foi possível adicionar o comentário.');
      }
    });
  }

  public salvar(): void {
    if (this.possuiChecklistInvalido()) return;
    this.dialogRef.close({ cartao: this.data.cartao });
  }

  public arquivar(): void {
    this.dialogRef.close({ arquivar: true });
  }

  public cancelar(): void {
    this.dialogRef.close();
  }
}
